






























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class CreatePurchaseOrderFromCommodity extends Vue {
  
  @Prop() public checkedReplenishmentCommodity:Array<Common.StockReplenishmentCommodity>; 

  // ワークフロー処理用プロパティ
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;
  // 発注処理用プロパティ
  public cpoWorkflowId: number = 0;
  public cpoPic:string = null;
  public cpoSegment:Common.Segment = null;
  public cpoAddExistPurchaseOrder = false;
  public cpoSupplier:Common.Counterpart = null;
  public cpoSupplierEnabled = false;
  public tenantSettings: Common.TenantSettings = null;


  // 発注処理ダイアログの表示
  public mounted(){
    this.tenantSettings = this.$api.tenantSettings;
    // ダイアログ表示前バリデーション
    if(this.checkedReplenishmentCommodity.length == 0){
      this.$api.modal.show('', '対象の商品を選択して下さい。', true, null);
      return;
    }
    // if(this.checkedReplenishmentCommodity.filter(item=>item.commodity.supplier==null).length > 0){
    //   this.$api.modal.show('', '仕入先が設定されている商品を選択して下さい。', true, null);
    //   return;
    // }
    // if(this.checkedReplenishmentCommodity.filter(item=>item.minimumStockQuantity==0).length>0){
    //   this.$api.modal.show('', '補充基準数量が"0"以外の商品のみを選択して下さい。', true, null);
    //   return;
    // }
    // if(this.checkedReplenishmentCommodity.filter(item=>item.replenishmentQuantity==0).length>0){
    //   this.$api.modal.show('', '補充数量が"0"以外の商品のみを選択して下さい。', true, null);
    //   return;
    // }
    // 異なる仕入先が設定されている商品のチェックがONになっている
    var supplierId:number = this.checkedReplenishmentCommodity[0].commodity.supplierId;
    if(this.checkedReplenishmentCommodity.filter(item=>item.commodity.supplierId!=supplierId).length>0){
      this.$api.modal.show('', '仕入先がすべて同一の商品を選択して下さい。', true, null);
      return;
    }
    if(supplierId == null) this.cpoSupplierEnabled = true;
    
    // 発注数量・単位・回答納期・入荷予定日の初期化
    this.checkedReplenishmentCommodity.forEach(obj => {
      obj.purchaseReplenishmentUom = obj.replenishmentUom;
      obj.purchaseReplenishmentQuantity = obj.replenishmentQuantity;
      obj.answerDeliveryDate = new Date().getCalendarDate();
      obj.scheduledDeliveryDate = new Date().getCalendarDate();
    });
    
    // プロパティの初期化
    this.cpoWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseOrder');
    this.onChangeWorkflow();
    this.cpoPic = this.$api.auth.userId;
    this.cpoSegment = null;
    this.cpoSupplier = null;

    // ダイアログの表示
    (this.$refs.createPurchaseOrderFromCommodityDialog as Components.ListDialog).items = this.checkedReplenishmentCommodity;
    (this.$refs.createPurchaseOrderFromCommodityDialog as Components.ListDialog).showDialog();
  }

  // 発注処理の実行
  public SubmitCreatePurchaseOrder(items:any[], index:number) {
    // クエリの設定
    var query = new Common.CreatePuchaseOrderFromCommodityQuery();
    query.stockReplenishmentCommodityList = this.checkedReplenishmentCommodity;
    query.currencyCode = this.$api.tenantSettings.currencyCode;
    query.pic = this.cpoPic;
    query.segment=this.cpoSegment;
    query.workflowId = this.cpoWorkflowId;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.addExistPurchaseOrder = this.cpoAddExistPurchaseOrder;
    query.supplier = this.cpoSupplier;
    (this.$refs.createPurchaseOrderFromCommodityDialog as Components.ListDialog).closeDialog();
    return this.$api.execute(query,true).then(res => {
      //トライアル中はロードマップを更新
      if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();      
      var orders = res as Common.Order[];
      var links = orders.map(order=>new Common.ModalLink(order.orderNo,String.format('/purchase/PurchaseOrder?orderNo={0}',order.orderNo)));
      var dialogMessage = '以下の発注伝票が作成・更新されました。';
      if(this.$api.tenantSettings.noCheckPriceRequired == false && orders.filter(order => order.hasNoPriceItem == true).length > 0) dialogMessage += '\r\n※単価の設定がされていない明細があります。';
      if(orders.length == 1){
        this.$api.modal.show('処理結果',dialogMessage,false,()=>{
          var url = String.format('/purchase/PurchaseOrder?orderNo={0}',orders[0].orderNo);
          if (url){ this.$router.push(url);}
        },links,'伝票に移動する','閉じる');
      }else{
        this.$api.modal.show('処理結果',dialogMessage,true,null,links,'閉じる');
      }

// ***** 予定在庫一覧画面からの発注処理成功確認 ※イベント計測は同じ条件でできるよう名称変更しない *****
this.$api.issueGA4trackevent(this.$route.path,'【補充商品一覧】発注処理・成功');

      return true;
    }).catch(()=>{ return false;});      
  }
  public onChangeWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("発注保存");
    if(this.cpoWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('purchaseOrder', this.cpoWorkflowId, Common.OrderStatus.PurchaseOrderSaving);
      actions.forEach(action => {
        this.buttonNames.push(action.actionName);
        this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
public count:number = 0;
  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.StockReplenishmentCommodity){
    this.$api.execute(new StockReplenishmentCommodityGetItemPriceQuery(item,this.cpoSegment,this.cpoSupplier)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }
  public getTaxType(item:Common.StockReplenishmentCommodity){
    return item.commodity?.supplier?.taxType ?? this.cpoSupplier?.taxType;
  }
}
class StockReplenishmentCommodityGetItemPriceQuery extends Common.Query{
  constructor(stockReplenishmentCommodity:Common.StockReplenishmentCommodity, segment:Common.Segment, supplier:Common.Counterpart){
    super('StockReplenishmentCommodityGetItemPriceQuery', new Common.ModelBinder(Common.StockReplenishmentCommodity, false));
    this.stockReplenishmentCommodity = stockReplenishmentCommodity;
    this.segment = segment;
    this.supplier = supplier;
  }
  public stockReplenishmentCommodity: Common.StockReplenishmentCommodity;
  public segment: Common.Segment;
  public supplier: Common.Counterpart;
}
